import Cookies from "js-cookie";

// The current document's explicit choice wins even if cookie writes are blocked.
// The HTML ad bootstrap reads the same snapshot at its asynchronous boundary.
export function setDocumentConsent(choice) {
  if (typeof window === "undefined") return;
  if (choice === null) { delete window.__ppConsent; return; }
  window.__ppConsent = { analytics: choice.analytics === true, marketing: choice.marketing === true };
}

export function readConsent() {
  if (typeof window !== "undefined" && window.__ppConsent) return { ...window.__ppConsent };
  try {
    const raw = Cookies.get("pp_consent");
    if (raw) {
      const value = JSON.parse(raw);
      return { analytics: value.analytics === true, marketing: value.marketing === true };
    }
    const legacy = Cookies.get("CookieConsent") === "true";
    return { analytics: legacy, marketing: legacy };
  } catch {
    return { analytics: false, marketing: false };
  }
}
